export default __webpack_public_path__ + "static/media/netvrk-v2-7.8bca2566.jpg";